import type { FC } from 'react';
import { Button, InlineNotification, Stack } from '@carbon/react';

import type { SocialProvider } from '@maestra/core/store/slices/auth';
import { LogoApple, LogoGoogle } from '../../marcas/LogosDeTerceiros';
import { ROTULOS, rotuloDoAviso } from '../../padroes/rotulos';
import styles from './auth.module.scss';

// As outras formas de entrar (padrão de login do Carbon: "alternative logins" abaixo do formulário).
// Cada provedor é um `Button` tertiary com o logotipo oficial, um embaixo do outro: o mesmo tipo e o
// mesmo tamanho e a mesma largura (o Sign in with Apple precisa da mesma proeminência do Google), e
// o rótulo inteiro numa linha, também no celular. O rótulo é o que as marcas pedem: "Entrar com o Google", "Entrar com a Apple".

const ROTULO: Record<SocialProvider, string> = { google: 'Entrar com o Google', apple: 'Entrar com a Apple', facebook: 'Entrar com o Facebook' };
const LOGO: Partial<Record<SocialProvider, typeof LogoGoogle>> = { google: LogoGoogle, apple: LogoApple };

export interface PropsDosProvedores {
  provedores: SocialProvider[];
  aviso: string | null;
  redirecionando: SocialProvider | null;
  entrar: (p: SocialProvider) => void;
}

export const EntrarComProvedor: FC<PropsDosProvedores> = ({ provedores, aviso, redirecionando, entrar }) => (
  <Stack gap={5} as='section' aria-labelledby='outras-formas'>
    <h2 id='outras-formas' className={styles.separador}>Outras formas de entrar</h2>
    <Stack gap={3}>
      {provedores.map((p) => (
        <Button
          key={p}
          kind='tertiary'
          size='lg'
          className={styles.provedor}
          renderIcon={LOGO[p]}
          disabled={redirecionando !== null}
          onClick={() => entrar(p)}
        >
          {redirecionando === p ? 'Redirecionando…' : ROTULO[p]}
        </Button>
      ))}
    </Stack>
    {aviso && <InlineNotification kind='warning' lowContrast hideCloseButton title={aviso} statusIconDescription={rotuloDoAviso('warning')} aria-label={ROTULOS.fecharAviso} />}
  </Stack>
);
